function PrivacyPolicyPage() {
  return (
    <section id="privacy-policy" className="page-section section-even legal">
      <div className="section-inner">
        <h2>Privacy Policy</h2>
        <h3>1. INTRODUCTION</h3>
        <p>
          <strong>VEKAC SUPPLY LLC</strong> respects your privacy and is committed to protecting it through our
          compliance with this policy. This Privacy Policy describes how we collect, use, disclose, and
          safeguard your information when you visit our website at <strong>VEKAC SUPPLY LLC</strong> or use our
          services, including SMS messaging services. Please read this policy carefully to understand our
          policies and practices regarding your information.
        </p>

        <h3>2. INFORMATION WE COLLECT</h3>
        <h4>2.1 Personal Information</h4>
        <ul>
          <li>Contact information (name, email address, mailing address, phone number)</li>
          <li>Business information (company name, job title)</li>
          <li>Payment information (credit card numbers, billing address)</li>
          <li>Communication preferences</li>
          <li>Information you provide when you contact us</li>
        </ul>
        <h4>2.2 Non-Personal Information</h4>
        <ul>
          <li>Usage details (traffic data, location data, logs)</li>
          <li>Device information (IP address, browser type, operating system)</li>
          <li>Information collected through cookies, web beacons, and tracking technologies</li>
        </ul>

        <h3>3. HOW WE COLLECT YOUR INFORMATION</h3>
        <h4>3.1 Direct Collection</h4>
        <ul>
          <li>Register on our website</li>
          <li>Place an order</li>
          <li>Subscribe to our newsletter</li>
          <li>Request information</li>
          <li>Fill out a form</li>
          <li>Communicate with us via phone, email, or otherwise</li>
          <li>Opt-in to receive SMS messages</li>
        </ul>
        <h4>3.2 Automatic Collection</h4>
        <ul>
          <li>Details of your visits to our website</li>
          <li>Information about your computer and internet connection</li>
          <li>Details about your device and location</li>
        </ul>

        <h3>4. SMS MESSAGING PROGRAM</h3>
        <h4>4.1 Opt-In</h4>
        <p>
          When you provide your mobile phone number and consent to receive SMS messages from us, you are
          expressly consenting to receive recurring automated marketing and promotional SMS messages from
          <strong> VEKAC SUPPLY LLC</strong> at the cell number provided.
        </p>
        <h4>4.2 Message Frequency</h4>
        <p>Message frequency varies. You may receive up to 4 messages per month related to:</p>
        <ul>
          <li>Order confirmations and updates</li>
          <li>Promotional offers</li>
          <li>Service announcements</li>
          <li>Appointment reminders</li>
        </ul>
        <h4>4.3 Opt-Out</h4>
        <ul>
          <li>Replying &quot;STOP&quot; to any message we send</li>
          <li>
            Contacting us at <a href="mailto:support@vekac-supply.com">support@vekac-supply.com</a>
          </li>
        </ul>
        <h4>4.4 Help</h4>
        <p>
          For assistance with our SMS program, reply &quot;HELP&quot; to any message we send or contact us at{' '}
          <a href="mailto:support@vekac-supply.com">support@vekac-supply.com</a>.
        </p>
        <h4>4.5 Carrier Charges</h4>
        <p>
          Message and data rates may apply for any messages sent to or from you. Please contact your wireless
          carrier for information about your messaging plan.
        </p>

        <h3>5. HOW WE USE YOUR INFORMATION</h3>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Process transactions and send related information</li>
          <li>Send promotional messages and offers (if you have opted in)</li>
          <li>Respond to comments, questions, and requests</li>
          <li>Notify you about changes to our services</li>
          <li>Analyze usage patterns and improve our website</li>
          <li>Protect our rights and investigate violations of our policies</li>
        </ul>

        <h3>6. DISCLOSURE OF YOUR INFORMATION</h3>
        <ul>
          <li>To our subsidiaries and affiliates</li>
          <li>To contractors, service providers, and other third parties supporting our business</li>
          <li>To comply with any court order, law, or legal process</li>
          <li>To enforce our Terms of Service</li>
          <li>If disclosure is necessary to protect rights, property, or safety</li>
        </ul>
        <p>We do not sell, rent, or lease customer lists to third parties.</p>

        <h3>7. DATA SECURITY</h3>
        <p>
          We have implemented measures designed to secure your personal information from accidental loss and
          unauthorized access, use, alteration, and disclosure. Although we do our best, no internet
          transmission is completely secure.
        </p>

        <h3>8. YOUR CHOICES ABOUT YOUR INFORMATION</h3>
        <p>
          You can review and change your personal information by logging in and visiting your account profile
          page. You may also email <a href="mailto:privacy@vekac-supply.com">privacy@vekac-supply.com</a> to request access
          to, correction of, or deletion of your personal information.
        </p>

        <h3>9. CHANGES TO OUR PRIVACY POLICY</h3>
        <p>
          We may update this Privacy Policy from time to time. Material changes will be posted on this page
          and may also be communicated by email or website notice.
        </p>

        <h3>10. CONTACT INFORMATION</h3>
        <p>To ask questions or comment about this Privacy Policy and our privacy practices, contact us at:</p>
        <p>
          VEKAC SUPPLY LLC
          <br />
          7345 W SAND LAKE RD STE 210 OFFICE 4975 ORLANDO, FLORIDA
          <br />
          Email: <a href="mailto:privacy@vekac-supply.com">privacy@vekac-supply.com</a>
        </p>
      </div>
    </section>
  );
}

export default PrivacyPolicyPage;
